import { BfnStatus } from '@/models/Befehlsnachricht'
import { BfnStoreDataEntry } from '@/store/useBfnStore'

const HOURS_23 = 23 * 60 * 60 * 1000
const DAYS_365 = 365 * 24 * 60 * 60 * 1000

const RELEVANT_STATUSES = new Set([
  BfnStatus.ERSTELLT,
  BfnStatus.SMS_IM_VERSAND,
  BfnStatus.SMS_ZUGESTELLT,
  BfnStatus.ERSTABRUF_GESTARTET,
  BfnStatus.STANDORTBESTAETIGUNG_DURCH_TF_ERFORDERLICH,
  BfnStatus.STANDORTABGLEICH_DURCH_FDL_ERFORDERLICH,
  BfnStatus.ABGERUFEN,
  BfnStatus.STANDORTEINGABE_AKZEPTIERT,
  BfnStatus.QUITTIERT
])

const ARCHIVED_STATUSES = new Set([
  BfnStatus.ABGEWIESEN,
  BfnStatus.ERLEDIGT,
  BfnStatus.WIDERRUFEN,
  BfnStatus.STANDORTABGLEICH_FEHLGESCHLAGEN
])

export function getAgeMs(entry: BfnStoreDataEntry): number {
  return Date.now() - entry.befehlsnachricht.versandzeitpunkt.getTime()
}

function isZugnummerMatch(
  entry: BfnStoreDataEntry,
  zugnummer: string
): boolean {
  return String(entry.befehlsnachricht.zugnummer) === zugnummer
}

export function isRelevant(
  entry: BfnStoreDataEntry,
  zugnummer: string
): boolean {
  return (
    entry.manuellWiderrufenAt == undefined &&
    isZugnummerMatch(entry, zugnummer) &&
    RELEVANT_STATUSES.has(entry.befehlsnachricht.status) &&
    getAgeMs(entry) <= HOURS_23
  )
}

export function isArchived(
  entry: BfnStoreDataEntry,
  zugnummer: string
): boolean {
  const age = getAgeMs(entry)
  if (age > DAYS_365) return false

  return (
    !isZugnummerMatch(entry, zugnummer) ||
    age > HOURS_23 ||
    ARCHIVED_STATUSES.has(entry.befehlsnachricht.status) ||
    entry.manuellWiderrufenAt !== undefined
  )
}

export function sortByDate<T extends BfnStoreDataEntry>(
  entries: [string, T][]
): [string, T][] {
  return entries.sort(([, a], [, b]) => {
    const dateA = a.abruftoken.tokenReceivedDate?.getTime() ?? -Infinity
    const dateB = b.abruftoken.tokenReceivedDate?.getTime() ?? -Infinity
    return dateB - dateA
  })
}
